/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardBookingDeleteController', BoardBookingDeleteController);

    BoardBookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Booking'];

    function BoardBookingDeleteController($uibModalInstance, entity, Booking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Booking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
